import {deleteAnalysisSteps} from 'analysis-tool/AnalysisActions';
import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import {recordAnalysisAction} from 'analysis-tool/ui/debugAnalysisActionHistory';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {DeletePipelineStepsBehavior} from 'pipelines/network/PipelineDAO';
import runConfirmDeleteModal from 'ui-library/modals/runConfirmDeleteModal';
import {withLoadingScreen} from 'util/Promises';

/**
 * Shared flow for deleting an analysis view: confirm → record → delete.
 *
 * Used by layout delete and data view delete actions.
 */
export default async function confirmAndDeleteAnalysisView({
  analysis,
  stepId,
  stepType,
  analysisClientStateId,
  typeName,
}: {
  analysis: AnalysisGraphQL;
  stepId: string;
  stepType: PipelineStepType;
  analysisClientStateId: string;
  typeName: string;
}): Promise<void> {
  const confirmed = await runConfirmDeleteModal({typeName});
  if (!confirmed) {
    return;
  }
  recordAnalysisAction('DELETE_VIEW', {
    analysisId: analysis.id,
    stepId,
    firstStepType: stepType,
  });
  await withLoadingScreen(
    deleteAnalysisSteps(
      analysis,
      {
        stepIds: [stepId],
        behavior: DeletePipelineStepsBehavior.DELETE_ALL_CHILDREN,
      },
      analysisClientStateId
    )
  );
}
